<md-dialog>
	<div md-dialog-header>
		<span class="md-text-xl-semibold">{{ isEdit() ? 'Edit' : 'Add' }} User Tag</span>
	</div>

	@if (userTagTypesLoading()) {
		<lb-loader></lb-loader>
	} @else if (tagTypes().length === 0) {
		<div class="no-tag-types">
			<span class="md-text-md-regular">No tag types are available. Please contact an administrator to create user tag types.</span>
		</div>
	} @else {
		<div class="tag-form" [formGroup]="tagForm">
			<div class="form-field">
				<label class="md-text-sm-semibold">Type </label>
				<md-drop-down
					md-form-input
					md-select-input
					formControlName="tagType"
					[required]="true"
					[options]="tagOptions()"
					[value]="tagForm.get('tagType')?.value"
					(change)="setTagType($event)"
				>
				</md-drop-down>
			</div>

			<div class="form-field">
				<label class="md-text-sm-semibold">Notes</label>
				<textarea md-form-input id="notes" formControlName="notes" class="form-control" rows="3" placeholder="Add any additional notes..."></textarea>
			</div>

			<div class="form-field">
				<label class="md-text-sm-semibold" for="returnDate">Expected Date</label>
				<input type="date" formControlName="returnDate" md-form-input md-date-picker-input [disabledDateFn]="disablePastDates()" />
			</div>
		</div>
	}

	<div md-dialog-footer>
		@if (isEdit()) {
			<button md-button-warning (click)="confirmDelete()">Delete</button>
		}
		<button md-button (click)="close()">Cancel</button>
		<button md-button-brand (click)="confirm()">Save</button>
	</div>
</md-dialog>
